// extracted by mini-css-extract-plugin
export var brokercontactcard = "brokercontactcard-module--brokercontactcard--966ce";
export var listitem = "brokercontactcard-module--listitem--fc5e6";
export var listitemlink = "brokercontactcard-module--listitemlink--63cb0";
export var listitemtext = "brokercontactcard-module--listitemtext--237b8";